import { wsService } from "./wsService";

const section = "general";

function list_doc_types(param = { enable: true }) {
  return wsService.make_post_request(section + "/list-doc-types", param);
}

function list_genders(param = {}) {
  return wsService.make_post_request(section + "/list-genders", param);
}

function list_civil_status(param = {}) {
  return wsService.make_post_request(section + "/list-civil-status", param);
}

function list_level_studies(param = {}) {
  return wsService.make_post_request(section + "/list-level-studies", param);
}

function list_provinces(param = {}) {
  return wsService.make_post_request(section + "/list-provinces", param);
}

export const listService = {
  section,
  list_doc_types,
  list_civil_status,
  list_genders,
  list_level_studies,
  list_provinces
};
